import { History, LocationListener, UnregisterCallback, LocationDescriptor, TransitionPromptHook, LocationDescriptorObject } from 'history';
import { BrowserRouter } from 'react-router-dom';
import Queue from '../sdk/Queue';

// @ts-ignore
const globalHistory = BrowserRouter.globalHistory;

/**
 * TODO:
 * 1. 处理history的创建销毁
 * 2. 处理history.listenr监听
 * 3. 处理history.unlistener取消监听
 * 4. 处理history.push,replace等方法
 */

 type HistoryEvent = CustomEvent<{ key: string; history: History }>;

 type ListenerTask = { listener: LocationListener<any>; unlisteners: UnregisterCallback[] };

// /* 创建history时触发的事件 */
// const createHistoryEvent = 'createBrowserRouterHistory';

// /* 销毁history时触发的事件 */
// const destoryHistoryEvent = 'destoryBrowserRouterHistory';

function noop () {};

class HistoryUtil {

  public mainHistory: History | null = globalHistory;

  private historyQueue = new Map<string, History>();

  private listenerQueue = new Queue<ListenerTask>();

  // constructor() {
    // window.addEventListener(createHistoryEvent, this.createHistory);
    // window.addEventListener(destoryHistoryEvent, this.destoryHistory);
  // }

  getMainHistory = () => {
    return this.mainHistory;
  }

  createHistory = (e: Event) => {
    const event = e as HistoryEvent;
    const { key, history } = event.detail || {};
    if (this.historyQueue.size === 0) {
      // 将第一个history作为主要的history
      this.mainHistory = history;
    }
    this.initListener(history);
    this.historyQueue.set(key, history);
  }

  destoryHistory = (e: Event) => {
    const event = e as HistoryEvent;
    const { key } = event.detail || {};
    this.historyQueue.delete(key);
  }

  initListener = (history: History) => {
    this.listenerQueue.queue.forEach(listenerId => {
      const { listener, unlisteners } = this.listenerQueue.get(listenerId) || {};
      if (listener && unlisteners) {
        unlisteners.push(history.listen(listener));
      }
    });
  }

  // listen = (listener: LocationListener<any>) => {
    // const historyIter = this.historyQueue.keys();
    // const unlisteners: UnregisterCallback[] = [];
    // const listenerId = this.listenerQueue.push({ listener, unlisteners });
    // let historyId;
    // while(!(historyId = historyIter.next()).done) {
    //   const history = this.historyQueue.get(historyId.value);
    //   if (history) {
    //     unlisteners.push(history.listen(listener));
    //   }
    // }
    // return this.generatorUnlistener(listenerId);
  // }

  generatorUnlistener = (listenerId: string): UnregisterCallback => {
    const unlisten = () => {
      const { unlisteners } = this.listenerQueue.delete(listenerId) || {};
      unlisteners?.forEach(unlistener => {
        if (typeof unlistener === 'function') {
          unlistener();
        }
      });
    }
    return unlisten;
  }

  // 重写history原生的方法
  go = (n: number): void => {
    return this.mainHistory?.go(n);
  }

  goBack = (): void => {
    return this.mainHistory?.goBack();
  }

  goForward = (): void => {
    return this.mainHistory?.goForward();
  }

  block = (prompt?: boolean | string | TransitionPromptHook<any>) => {
    return this.mainHistory?.block(prompt) || noop;
  }

  createHref = (location: LocationDescriptorObject<any>) => {
    return this.mainHistory?.createHref(location) || '';
  }

  listen = (listener: LocationListener<any>) => {
    return this.mainHistory?.listen(listener) || noop;
  }

  push = (path: string | LocationDescriptor<any>, state?: any): void => {
    if (typeof path === 'string') {
      return this.mainHistory?.push(path, state);
    } else {
      return this.mainHistory?.push(path);
    }
  }

  replace = (path: string | LocationDescriptor<any>, state?: any): void => {
    if (typeof path === 'string') {
      return this.mainHistory?.replace(path, state);
    } else {
      return this.mainHistory?.replace(path);
    }
  }
}

const historyUtil = new HistoryUtil();

const history = {
  go: historyUtil.go.bind(historyUtil),
  goBack: historyUtil.goBack.bind(historyUtil),
  goForward: historyUtil.goForward.bind(historyUtil),
  push: historyUtil.push.bind(historyUtil),
  replace: historyUtil.replace.bind(historyUtil),
  block: historyUtil.block.bind(historyUtil),
  listen: historyUtil.listen.bind(historyUtil),
  createHref: historyUtil.createHref.bind(historyUtil),
};

// const history = globalHistory as History;

export { historyUtil };

export default history;
